import * as React from 'react';
import * as _ from 'lodash';

import { Formatters } from '../common/formatters';

export const GetFormDataComponent = (component: any) => {
    let result = {
        _id: Formatters.getStr(component, '_id'),
        componentId: Formatters.getInt(component, 'componentId'),
        name: Formatters.getStr(component, 'name'),
        componentCategoryId: Formatters.getInt(component, 'componentCategoryId'),
        category: Formatters.getStr(component, 'category'),
        summary: Formatters.getStr(component, 'summary'),
        usefulLife: Formatters.getInt(component, 'usefulLife'),
        locations: _.get(component, 'locations', []),
        inactive: Formatters.getBool(component, 'inactive'),
    };

    return result;
};



// WEBPACK FOOTER //
// ./src/component/common.tsx